import { IceCream, Flame, Wheat, Sparkles } from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATIONS = [
  { id: 'Poste Mezzés Froids-Desserts', label: 'Mezzés Froids & Desserts', icon: IceCream, color: 'text-neon-pink', border: 'border-neon-pink/30', bg: 'bg-neon-pink/10', dot: 'bg-neon-pink' },
  { id: 'Poste Josper', label: 'Josper', icon: Flame, color: 'text-orange-600', border: 'border-orange-500/30', bg: 'bg-orange-500/10', dot: 'bg-orange-500' },
  { id: 'Poste Mezzés Chauds', label: 'Mezzés Chauds', icon: Flame, color: 'text-red-600', border: 'border-red-500/30', bg: 'bg-red-500/10', dot: 'bg-red-500' },
  { id: 'Poste Four à Pain', label: 'Four à Pain', icon: Wheat, color: 'text-amber-700', border: 'border-amber-300', bg: 'bg-amber-50', dot: 'bg-neon-yellow' },
  { id: 'Poste Préparation', label: 'Préparation', icon: Sparkles, color: 'text-emerald-600', border: 'border-emerald-500/30', bg: 'bg-emerald-500/10', dot: 'bg-emerald-500' },
];

export const stationLabel = (id) => STATIONS.find(s => s.id === id)?.label || (id || '').replace('Poste ', '') || 'Sans catégorie';

export const UNIT_OPTIONS = ['kg', 'g', 'ltr', 'pce', 'colis', 'bte', 'sac', 'portion'];

export const SERVICES = [
  { value: 'matin', label: 'Matin' },
  { value: 'midi', label: 'Midi' },
  { value: 'soir', label: 'Soir' },
  { value: 'journee', label: 'Journée' },
];
export const serviceLabel = (v) => SERVICES.find(s => s.value === v)?.label || v;

export const PRIORITIES = [
  { value: 'basse', label: 'Basse', cls: 'bg-gray-100 text-gray-600 border-gray-200' },
  { value: 'normale', label: 'Normale', cls: 'bg-sky-50 text-sky-700 border-sky-200' },
  { value: 'haute', label: 'Haute', cls: 'bg-amber-50 text-amber-700 border-amber-300' },
  { value: 'urgente', label: 'Urgente', cls: 'bg-red-600 text-white border-red-700' },
];
export const priorityMeta = (v) => PRIORITIES.find(p => p.value === v) || PRIORITIES[1];

export const STATUSES = [
  { value: 'brouillon', label: 'Brouillon', cls: 'bg-gray-100 text-gray-600 border-gray-200', dot: 'bg-gray-400' },
  { value: 'a_faire', label: 'À faire', cls: 'bg-blue-50 text-blue-700 border-blue-200', dot: 'bg-blue-500' },
  { value: 'en_cours', label: 'En cours', cls: 'bg-orange-50 text-orange-700 border-orange-300', dot: 'bg-orange-500' },
  { value: 'terminee', label: 'Terminée', cls: 'bg-emerald-50 text-emerald-700 border-emerald-300', dot: 'bg-emerald-500' },
  { value: 'non_realisee', label: 'Non réalisée', cls: 'bg-red-50 text-red-700 border-red-300', dot: 'bg-red-500' },
  { value: 'a_valider', label: 'À valider (ancien)', cls: 'bg-violet-50 text-violet-700 border-violet-300', dot: 'bg-violet-500' },
  { value: 'validee', label: 'Validée', cls: 'bg-emerald-50 text-emerald-700 border-emerald-300', dot: 'bg-emerald-500' },
  { value: 'refusee', label: 'Refusée', cls: 'bg-red-50 text-red-700 border-red-300', dot: 'bg-red-500' },
  { value: 'annulee', label: 'Annulée', cls: 'bg-gray-100 text-gray-500 border-gray-200 line-through', dot: 'bg-gray-300' },
];
export const statusMeta = (v) => STATUSES.find(s => s.value === v) || STATUSES[1];

export const HISTORY_LABELS = {
  creation: 'Création',
  statut: 'Changement de statut',
  affectation: 'Affectation',
  modification: 'Modification',
  archivage: 'Archivage',
  prise_en_charge: 'Prise en charge',
};

export const isMyTask = (task, user) => {
  const ids = (task?.assigned_user_ids || []);
  return !!user && ids.some(id => id === user.member_id || id === user.id);
};

export const formatTime = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleString('fr-FR', { timeZone: 'Europe/Zurich', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
};

export const newRequestId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
